Array.prototype.delayEach =
    function(interval, callback, initialDelay = null)
	{
		let delay = initialDelay || 0;
		for(let i = 0; i < this.length; i++)
		{
			callback.after(delay, this[i]);
			delay += interval;
		}
		return this;
	};

Array.prototype.mapToObject =
	function(keyValueMapper)
	{
		let out = {};
		this.forEach((value, i) =>
		{
			let keyValue = keyValueMapper(value, i);
			for(let key in keyValue)
				if (keyValue.hasOwnProperty(key))
					out[key] = keyValue[key];
		});
		return out;
	};

/**
 * Gets the list of checked values in a list of checkbox or radio input elements.
 * @param {RadioNodeList|HTMLInputElement[]} list
 * @return {string[]}
 */
export function checkedValues(list)
{
	return Array.from(list)
		.filter((element) => element.checked)
		.map((element) => element.value);
}

/**
 * Gets the list of checked values in a list of checkbox or radio input elements.
 * @param {RadioNodeList|HTMLInputElement[]} list
 * @param {string[]} values
 * @return {string[]}
 */
export function checkValues(list, values)
{
	Array.from(list)
		.filter((element) => values.indexOf(element.value) !== -1)
		.forEach((element) => {
			element.checked = true;
			$(element).trigger('change');
		});
}
